"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fields = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdTable = _interopRequireDefault(require("cccisd-table"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
var _cccisdFormik = require("cccisd-formik");
var _EditTagBtn = _interopRequireDefault(require("./EditTagBtn"));
var _generateNewId = require("../../../../../helpers/generateNewId.js");
var _style = _interopRequireDefault(require("./style.css"));
var _find2 = _interopRequireDefault(require("lodash/find"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var fields = exports.fields = ['tags[].id', 'tags[].name', 'tags[].label'];
var TagTable = function TagTable(props) {
  var tags = props.fields.tags;
  var settings = props.settings;
  var handleValidate = function handleValidate(values) {
    var errors = {};
    if (!values.label) {
      errors.label = 'Tag label is required.';
    }
    var proposedHandle = typeof values.name === 'undefined' ? values.label : values.name;
    var f = (0, _find2["default"])(tags, function (item) {
      return item.name.value === proposedHandle;
    });
    if (typeof f !== 'undefined') {
      errors.name = 'Internal Name already exists';
    }
    return errors;
  };
  var deleteTag = function deleteTag(id) {
    var deletedIndex = tags.findIndex(function (tag) {
      return tag.id.value === id;
    });
    tags.removeField(deletedIndex);
  };
  var updateTag = function updateTag(values) {
    var updatedTag = tags.find(function (tag) {
      return tag.id.value === values.id;
    });
    updatedTag.label.onChange(values.label);
    updatedTag.name.onChange(values.name);
    (0, _cccisdNotification["default"])('The tag has been updated');
  };
  var handleAddTag = function handleAddTag(values, _ref) {
    var resetForm = _ref.resetForm;
    tags.addField({
      id: (0, _generateNewId.generateNewId)({
        prefix: values.label,
        settings: settings.tags
      }),
      label: values.label,
      name: values.name || values.label
    });
    resetForm({});
  };
  var columns = [{
    name: 'label',
    label: 'Label',
    sort: true
  }, {
    name: 'name',
    label: 'Internal Name',
    sort: true
  }, {
    name: 'actions',
    label: 'Actions',
    "class": 'text-center',
    render: function render(value, row) {
      return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_EditTagBtn["default"], {
        onSuccess: updateTag,
        initialValues: row
      }), ' ', /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        title: /*#__PURE__*/_react["default"].createElement(_cross["default"], null),
        className: "btn btn-danger btn-xs",
        isConfirm: true,
        confirmationMessage: "Are you sure you want to delete this tag: ".concat(row.label, "?"),
        onClick: deleteTag.bind(null, row.id)
      }));
    }
  }];
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    validate: handleValidate,
    onSubmit: handleAddTag,
    render: function render() {
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].horizontal
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "label",
        component: _cccisdFormik.CccisdInput,
        label: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Tag label is what is displayed in the Resource Center."
        }, "Tag label ", /*#__PURE__*/_react["default"].createElement(_question["default"], null), " ", /*#__PURE__*/_react["default"].createElement("span", {
          style: {
            color: 'red'
          }
        }, "*"))
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "name",
        component: _cccisdFormik.CccisdInput,
        label: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Internal name should be unique. Generally, you should set it to be the same as Tag Label, unless you want two different tags with the same label."
        }, "Tag internal name ", /*#__PURE__*/_react["default"].createElement(_question["default"], null))
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-primary",
        type: "submit"
      }, "Add Tag"))));
    }
  }), settings.tags.length > 0 && /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
    rowKey: "id",
    data: settings.tags,
    columns: columns,
    orderBy: "label",
    isAscentOrder: true
  }));
};
TagTable.propTypes = {
  fields: _propTypes["default"].object,
  settings: _propTypes["default"].object
};
var _default = exports["default"] = TagTable;